module.exports = __webpack_public_path__ + "static/pemalex_img_malharia_3_h-66afd72ae57fd29973c4aa494ac4130c.jpg";